<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>International Professional Risks is registered in England and
            Wales under company number 04935842 and its registered office is 50
            Fenchurch Street, London EC3M 3JY, United Kingdom. International
            Professional Risks can be contacted by post at the address indicated
            above or by e-mail
            (<a href="mailto:info@fisg.co.uk">info@fisg.co.uk</a>).
            International Professional Risks is authorized and regulated by the
            Financial Conduct Authority (FRN: 311292)
          </span>
        </p>
        <p>
          <br>
          <span>Build No: {{version}} </span> <br>
          <span>COPYRIGHT &copy; </span>
          <span>Furness Insurance Services </span>
          <span>{{ new Date().getFullYear() }} </span>
        </p>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    },
    version: {
      type: Number
    }
  },
}
</script>
<style lang="scss">
.the-footer {
  font-size: 13px;
  padding: 1rem 2.2rem;
}
</style>
